import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Dialog,
  Icon,
  Input,
  OverlayTrigger,
  PopOver,
  RadioGroup,
  Select,
  SelectTree
} from '@tencent/spaui';
import { message } from "@tencent/ptp-fe-common";
import _ from 'lodash';
import { Tags } from '../../../consts/Tags';
import { RPCFactory } from '../../../utils/RequestUtil';
import { uploadSteps } from './uploadSteps';
import { StateSelectionComponent } from '../leadsmanage/ListViewLeadsManagePage';
import DynamicInputGroup from "../../common/DynamicInputGroup";

// 这里转化allRoles的actionType
const ruleTypeMapping = {
  CONFIRM_EFFECTIVE_LEADS: {
    title: '有效综合线索',
    iconDesc: '回访判断该线索是符合营销目标的，可用于优化表单有效率，是投放端深层优化目标之一',
  },
  CONFIRM_POTENTIAL_CUSTOMER: {
    title: '潜在线索',
    iconDesc: '回访判断该线索符合营销目标的基础上，意向程度较有效综合线索更高',
  },
  VISIT_STORE: {
    title: '到店线索',
    iconDesc: '回访后已成功邀约用户到店或预约上门',
  },
  PURCHASE: {
    title: '付费线索',
    iconDesc: '用户付费下单，可用于优化用户付费下单率，是投放端深层优化目标之一',
  },
  INEFFECTIVE_LEADS: {
    title: '无效线索',
    iconDesc: '用户存在恶意行为，如恶意骚扰非本人停机空号等，可用于减少负向人群',
  },
};
const ruleItemNameMapping = {
  leadsIntentionScoreTag: '线索评分',
  leadsCallCleaningTag: '智能标签',
  TAG: '线索标签',
  leadsStatus2: '线索状态',
  outerLeadsConvertType: '自定义线索状态',
};
const ruleReportOptions = [{
  value: 'BASIC',
  children: '基础上报',
}, {
  value: 'VALUE_SCORE',
  children: '转化价值分上报',
  TipComponent: () => {
    return  <OverlayTrigger
      trigger="hover"
      placement="right"
      alignment="top"
      overlay={
        <PopOver
          style={{
            maxWidth: '420px'
        }}
        >
          启用有效线索转化价值分上报后，模型可基于转化价值进行建模优化，可助您获取更多高转化价值的有效线索。 建议设置5档以上，至少保留3档
        </PopOver>
      }
    >
      <i className="icon icon-help" style={{ marginLeft: 8, marginBottom: -2 }}/>
    </OverlayTrigger>
  },
}];

const BASIC_REPORT = _.head(ruleReportOptions).value;
const VALUE_SCORE_REPORT = _.last(ruleReportOptions).value;
const ruleReportType = "CONFIRM_EFFECTIVE_LEADS";

const ruleItemLabelValueMapping = Object.keys(ruleItemNameMapping).map(
  (key, index) => ({
    label: ruleItemNameMapping[key],
    value: key,
  }));

const ruleItemTagMapping = {
  leadsIntentionScoreTag: 'leadsIntentionTag',
  leadsCallCleaningTag: 'leadsCallCleaningTagEdit',
  leadsTagDesc: null,
  leadsStatus2: 'leadsStatus2',
  outerLeadsConvertType: null,
};

const ValueScorePattern = new RegExp("^([1-9]|10)$");
export const LeadsDataUpload = (props) => {
  const industry = useSelector((state) => state.global);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [editActionTypeItem, setEditActionTypeItem] = useState({});
  const [allRoles, setAllRoles] = useState([]);
  const [tagGroups, setTagGroups] = useState([]); // 标签组树形结构数据
  const [tagNames, setTagNames] = useState([]); // 标签名称
  const [tagNamesList, setTagNamesList] = useState([]); // 标签名称
  const [ruleLabelValueList, setRuleLabelValueList] = useState([ruleItemLabelValueMapping]); // 可选属性结构列表

  const updateMapping = (item, reportCondition) => {
    let newRulesItem = getApplyRanges(editActionTypeItem);
    if (!_.isEmpty(item)) {
      newRulesItem = reportCondition === VALUE_SCORE_REPORT ? getApplyRanges(item) : item?.applyRange;
    }
    return Object.keys(ruleItemNameMapping).map((key) => ({
      label: ruleItemNameMapping[key],
      value: key,
      disabled:
        !!newRulesItem &&
        (!!_.find(newRulesItem?.applyRangeDetail,
            { fieldName: key })
          || !!_.find(newRulesItem?.applyRangeDetail,
            { fieldScope: key })
        ),
    }));
  };
  const transformTagGroups = (tagGroupEntities) => {
    const tagGroups = _.filter(tagGroupEntities, 'tagCount');
    const tags = tagGroups.map((tagGroupItem) => ({
      value: tagGroupItem.tagGroupId,
      desc: tagGroupItem.tagGroupName,
      options: tagGroupItem.tagList.map((tagItem) => ({
        value: tagItem.tagId,
        desc: tagItem.tagName,
      })),
    }));
    setTagGroups(tags);
  };
  useEffect(() => {
    RPCFactory.dmpReport
    .getLeadsDmpReport({})
    .done((data) => {
      const reports = (data.entities || []).filter(Boolean);
      const rules = _.map(reports, ({ actionType = {}, valueScoreApplyRanges: valueScores = [] }, index) => {
        const item = reports[index];
        let params = { ...item }
        if (actionType === ruleReportType) {
          // 如果详情数据不包含valueScoreApplyRanges, 手动填充
          let valueScoreApplyRanges = valueScores;
          if (!_.isEmpty(valueScores)) {
            valueScoreApplyRanges = _.map(valueScores, item => ({ applyRange: item }));
          }
          params = _.assign(params, { valueScoreApplyRanges })
        }
        return params;
      })
      setAllRoles(rules);
      getTagLabelsFromIds(rules);
    })
    .fail((ret, msg) => {
      alert(msg);
    });
    RPCFactory.labelGroupManage
    .getGroups({ withChildren: true })
    .done((data) => {
      const groups = (data.entities || []).filter(Boolean);
      transformTagGroups(groups);
    })
    .fail((ret, msg) => {});
  }, []);

  const [ruleSize, setRuleSize] = useState(0);
  const [cloneEditActionTypeItem, setCloneEditActionTypeItem] = useState({});

  // 详情项默认值
  const defaultApplyRangeDetailItem = {
    fieldScope: '',
    fieldName: '',
    matchRelation: 'IN',
    fieldValues: [],
  };

  // 重置条件规则列表， 各个规则之间选项互斥 by fighting
  const resetRuleLabelList = (showCondition, reportCondition) => {
    if (showCondition) {
      const editActionTypeData = reportCondition === VALUE_SCORE_REPORT ? editActionTypeItem : [valueBasicData];
      setRuleLabelValueList(_.map(editActionTypeData, item => updateMapping(item, reportCondition)));
    } else {
      setRuleLabelValueList([updateMapping()]);
    }
  };

  useEffect(() => {
    //   getTagLabelsFromIds(allRoles);
    resetRuleLabelList(showCondition, reportCondition);
    const markList = getMarkDuplicateData(getEditActionTypeItem(editActionTypeItem));
    console.log('标记后的数据', markList);
    setCloneEditActionTypeItem(markList);
  }, [editActionTypeItem])


  // tagId转获取tag标签接口 by figthing
  const fetchTagLabels = (callback, tagIds) => {
    RPCFactory.labelManage.getLabels({ tagIds })
    .done((data) => {
      callback(data);
    })
    .fail((ret, msg) => {
      alert(msg);
    });
  }

  const getTagLabelsFromIds = (entities) => {
    const tagCount = _.reduce(entities, function (sum, item) {
      const data = getApplyRanges(item);
      if(_.isArray(data)){
        _.forEach(data, valueItem => (
          sum + _.filter(valueItem?.applyRange?.applyRangeDetail, { fieldScope: 'TAG' }).length
        ))
        return sum;
      }
      return sum + _.filter(item.applyRange.applyRangeDetail, { fieldScope: 'TAG' }).length;
    }, 0);
    let tagNameCount = 0;
    const tagNamesNew = _.cloneDeep(tagNames);
    _.forEach(entities, (rules, index) => {
      const data = getApplyRanges(rules);
      if(_.isArray(data)){
        let tagNameListCount = 0;
        const tagNamesNewList = _.cloneDeep(tagNamesList);
        _.forEach(data, (valueItem, valueIndex) => {
          _.forEach(valueItem?.applyRange?.applyRangeDetail, (item) => {
            if (item.fieldScope === 'TAG') {
              fetchTagLabels((data) => {
                tagNamesNewList[valueIndex] = _.map(data.entities, (item) => item.tagName);
                tagNameListCount = tagNameListCount + 1;
                // if (tagCount === tagNameListCount) {
                  setTagNamesList(tagNamesNewList);
                // }
              }, item.fieldValues)
            }
          });
        })
      } else {
        _.forEach(rules?.applyRange?.applyRangeDetail, (item) => {
          if (item.fieldScope === 'TAG') {
            fetchTagLabels((data) => {
              tagNamesNew[index] = _.map(data.entities, (item) => item.tagName);
              tagNameCount = tagNameCount + 1;
              if (tagCount === tagNameCount) {
                setTagNames(tagNamesNew);
              }
            }, item.fieldValues)
          }
        });
      }
    })
  };

  const getLabelsFromIds = (item) => {
    if (item.fieldScope === 'TAG') {
      return [];
    }
    if (item.fieldName === 'leadsStatus2') {
      const map = {};
      industry.stateQueryOptions.forEach((elm) => {
        map[elm.value] = elm.label;
      });
      return item.fieldValues.map((val) => map[val]).filter(Boolean);
    }
    if (ruleItemTagMapping[item.fieldName]) {
      return item.fieldValues.map(
        (value) => Tags[ruleItemTagMapping[item.fieldName]][value]);
    }
    return item.fieldValues;
  };
  const getValuesFromIds = (item) => {
    if (item.fieldScope === 'TAG') {
      return [];
    }
    if (ruleItemTagMapping[item.fieldName]) {
      return item.fieldValues;
    }
    return item.fieldValues;
  };

  // 给重复标签打标记 by fighting
  const getMarkDuplicateData = (data) => {
    const prefix = '-';
    // 1.组装以fieldName为key的所有包含fieldValues的集合
    const scoreMap = [];
    const fieldMap = _.reduceRight(_.map(data, (item, parentId) => {
      scoreMap.push({
        parentId,
        score: item?.applyRange?.score,
      });
      return _.map(item?.applyRange?.applyRangeDetail, ({ fieldName = '', fieldValues = [] }, childId) => ({
        parentId,
        childId,
        fieldName,
        fieldValues,
      }));
    }), (a, b) => _.concat(a, b));
    // 不包含applyRange?.applyRangeDetail 直接返回原数据
    if (_.isEmpty(fieldMap)) {
      return data;
    }
    const fieldNameGroup = _.groupBy(fieldMap, 'fieldName'); // 按fieldName聚合
    // 获取重复出现的数组map
    const fieldDuplicateMap = _.reduceRight(_.map(_.keys(fieldNameGroup), (duplicateKey) => {
      const ary = Array.from(_.map(fieldNameGroup[duplicateKey]));
      let indexList = _.map(ary, (item, index) => index);
      // 构造数组下标的排列组合，保证对比每一个数据
      indexList = Array.from(indexList, x => Array.from(indexList, y => (x < y ? `${x}${prefix}${y}` : '')));
      indexList = _.flatMap(_.map(indexList, item => _.compact(item)));
      return _.compact(_.map(indexList, (i) => {
        const split = i.split(prefix);
        const pre = _.head(split);
        const next = _.last(split);
        // console.log(pre, next);
        // x==y 对比number和string类型的值
        const duplicateList = _.intersectionWith(ary[pre].fieldValues, ary[next].fieldValues, (x, y) => (x == y));
        const isDuplicated = !_.isEmpty(duplicateList);
        if (isDuplicated) {
          // 存储key和对应重复值
          return {
            preId: ary[pre].parentId + prefix + ary[pre].childId,
            nextId: ary[next].parentId + prefix + ary[next].childId,
            duplicateKey,
            duplicateList,
          };
        }
      }));
    }), (a, b) => _.concat(a, b));
    // 2.记录判断转化价值分重复的对应项
    const scoreDuplicateMap = _.uniq(_.flatMap(_.differenceWith(
      scoreMap,
      _.uniqBy(scoreMap, 'score'),
    ), ({ score = '' }) => {
      // 匹配去重前后的scoreMap和去重后_.uniqBy(scoreMap, 'score')的差异项
      const scoreList = _.filter(scoreMap, ['score', score]);
      return _.map(scoreList, 'score');
    }));
    // 3.判断哪些项是重复的
    return _.map(data, (item, outerId) => ({
      ...item,
      applyRange: {
        ...item.applyRange,
        scoreDuplicateMap,
        applyRangeDetail: _.map(item?.applyRange?.applyRangeDetail, (children, innerId) => {
          const detail = children;
          detail.fieldValuesDuplicate = [];
          const judgeId = outerId + prefix + innerId; // 组合的索引Id
          // 当前项不包含重复项时设置fieldValuesDuplicate
          _.forEach(fieldDuplicateMap, ({ duplicateKey = '', duplicateList = [],  preId = '', nextId = '' } = {}) => {
            if (duplicateKey === detail.fieldName && (preId === judgeId || nextId === judgeId)) {
              // const ret = !_.isEmpty(_.intersectionWith(detail.fieldValues, duplicateList, (x, y) => (x == y)));
              // if (ret) {
              detail.fieldValuesDuplicate = duplicateList;
              //  }
            }
          });
          return detail;
        }),
      },
    }));
  };

  const getDataFromItem = (item) => {
    if (item.fieldName === 'outerLeadsConvertType') {
      // 自定义线索状态没有可选范围
      return [];
    }
    if (item.fieldScope === 'TAG') {
      return [];
    }
    const currentFilterAllData = Tags[ruleItemTagMapping[item.fieldName]];
    if (!currentFilterAllData) {
      return [];
    }
    return Object.keys(currentFilterAllData).map((key) => {
      return {
        label: currentFilterAllData[key],
        value: key,
      }
    });
  };

  const editRuleActionType = (item, valueScore) => {
    setEditDialogVisible(true);
    setEditActionTypeItem(_.cloneDeep(!_.isEmpty(valueScore)? valueScore: item));
  };

  const closeEditDialog = () => {
    setEditDialogVisible(false);
    setRuleSize(0);
  };

  const checkValid = (item) => {
    const invalid = _.findIndex(
      item?.applyRangeDetail, function (o) {
        return (!o.fieldName && !o.fieldScope) || o.fieldValues.length === 0;
      });
    return !(invalid > -1 && item?.applyRangeDetail.length > 0);
  }

  // 是否校验失败
  const validFail = () => {
    const ret1 = _.isArray(getActionTypeData().data);
    const ret2 = !_.every(getActionTypeData().data, item => {
        const checkApplyRange = checkValid(item?.applyRange);
        if (reportCondition === VALUE_SCORE_REPORT) {
          const scoreMatch = ValueScorePattern.test(item?.applyRange?.score);
          if (!scoreMatch) {
            // message.warning("请输入1-10的整数！");
            return checkApplyRange && scoreMatch
          }
        }
        return checkApplyRange
      }
    ) || ruleSize === 0;
    const ret3 = !checkValid(getActionTypeData().data?.applyRange);
    return ret1 ? ret2 : ret3;
  }

  const submitEditDialog = () => {
    const actionType = ruleReportType;
    const reportContentType = reportCondition;
    const applyRange = valueBasicData?.applyRange;
    let valueScoreApplyRanges = _.isArray(cloneEditActionTypeItem)
      ? cloneEditActionTypeItem : cloneEditActionTypeItem?.valueScoreApplyRanges
    // 按转化价值分排序
    valueScoreApplyRanges = _.orderBy(valueScoreApplyRanges, ['applyRange.score'], ['desc']);
    const submitValueScoreApplyRanges = _.map(valueScoreApplyRanges, 'applyRange')
    let params = showCondition? {
      actionType,
      reportContentType,
    }: editActionTypeItem;
    if (showCondition) {
      params = _.assign(
        params,
        reportContentType === BASIC_REPORT ? { applyRange } : { valueScoreApplyRanges: submitValueScoreApplyRanges }
      );
    }
    console.log('提交参数: ', params);
    if (validFail()) {
      message.error('表单校验未通过');
      return;
    }
    RPCFactory.dmpReport
    .setLeadsDmpReport(params)
    .done((data) => {
      let index = _.findIndex(allRoles, { actionType });
      const newAllRoles = _.cloneDeep(allRoles);
      if (showCondition) {
        if (index > -1) {
          newAllRoles[index].reportContentType = reportContentType;
          newAllRoles[index].applyRange = applyRange;
          newAllRoles[index].valueScoreApplyRanges = valueScoreApplyRanges;
        }
      } else {
        index = _.findIndex(allRoles, { actionType: cloneEditActionTypeItem.actionType });
        newAllRoles[index] = cloneEditActionTypeItem;
      }
      console.log('修改后的详情数据', newAllRoles);
      setAllRoles(newAllRoles);
      getTagLabelsFromIds(newAllRoles);
      setEditDialogVisible(false);
    })
    .fail((ret, msg) => {
      alert(msg);
    });
  };

  // 切换基础上报和转化上报 onchange 数据
  const getActionTypeData = () => {
    if (showCondition && reportCondition === BASIC_REPORT) {
      return { data: valueBasicData, resetActionTypeItem: false };
    }
    return { data: cloneEditActionTypeItem, resetActionTypeItem: true }
  }

  const changeRuleItemName = (curIndex, newValue, editIndex) => {
    const newEditItem = _.cloneDeep(getActionTypeData().data);
    const oldEditRuleApplyRange = getApplyRanges(cloneEditActionTypeItem, editIndex); // 旧的数据
    const newEditRuleApplyRange = getApplyRanges(newEditItem, editIndex); // 更改后的数据
    if (curIndex === 'scoreInput') {
      // 转化价值分输入
      newEditRuleApplyRange.score = newValue ? Number(newValue) : '';
    } else {
      let index = _.findIndex(
        oldEditRuleApplyRange?.applyRangeDetail, { fieldName: newValue });
      if (index > -1) {
        newEditRuleApplyRange.applyRangeDetail[index].fieldName = newValue;
      } else {
        index = _.findIndex(oldEditRuleApplyRange?.applyRangeDetail, { fieldScope: newValue });
      }
      _.remove(
        newEditRuleApplyRange.applyRangeDetail, (item) => item.fieldName === newValue || item.fieldScope === newValue,
      );
      const newEditRuleApplyRangeDetail = newEditRuleApplyRange.applyRangeDetail[curIndex] || {};
      newEditRuleApplyRangeDetail.fieldValues = [];
      if (newValue === 'TAG') {
        newEditRuleApplyRangeDetail.fieldScope = newValue;
      } else {
        newEditRuleApplyRangeDetail.fieldName = newValue;
        newEditRuleApplyRangeDetail.fieldScope = 'STANDARD';
      }
    }
    getActionTypeData().resetActionTypeItem? setEditActionTypeItem(newEditItem): setValueBasicApplyData(newEditItem);
    resetRuleLabelList(showCondition, reportCondition)
  };

  const changeRuleItemValues = (curIndex, newValue, editIndex) => {
    const newEditItem = _.cloneDeep(getActionTypeData().data);
    getApplyRanges(newEditItem, editIndex).applyRangeDetail[curIndex].fieldValues = newValue;
    getActionTypeData().resetActionTypeItem? setEditActionTypeItem(newEditItem): setValueBasicApplyData(newEditItem);
    resetRuleLabelList(showCondition, reportCondition)
  };

  const changeInputValues = (curIndex, newValue, editIndex) => {
    const newEditItem = _.cloneDeep(getActionTypeData().data);
    getApplyRanges(newEditItem, editIndex).applyRangeDetail[curIndex].fieldValues = newValue.split(/[,，]/);
    getActionTypeData().resetActionTypeItem? setEditActionTypeItem(newEditItem): setValueBasicApplyData(newEditItem);
    resetRuleLabelList(showCondition, reportCondition)
  };

  const deleteRuleItem = (index, editIndex) => {
    const newEditItem = _.cloneDeep(getActionTypeData().data);
    getApplyRanges(newEditItem, editIndex)?.applyRangeDetail.splice(index, 1);
    getActionTypeData().resetActionTypeItem? setEditActionTypeItem(newEditItem): setValueBasicApplyData(newEditItem);
    resetRuleLabelList(showCondition, reportCondition)
  };

  const addRuleItem = (editIndex) => {
    const newEditItem = _.cloneDeep(getActionTypeData().data);
    getApplyRanges(newEditItem, editIndex)?.applyRangeDetail.push(defaultApplyRangeDetailItem);
    getActionTypeData().resetActionTypeItem? setEditActionTypeItem(newEditItem): setValueBasicApplyData(newEditItem);
    resetRuleLabelList(showCondition, reportCondition)
  };

  // 渲染helpTips
  const renderHelpTips = (title, content) =>
    <div className="help-tips">
      <span>{title}</span>
      <OverlayTrigger
        trigger="hover"
        alignment="right"
        overlay={
          <PopOver>
            {content}
          </PopOver>
        }
      >
        <i className="icon icon-help" style={{ marginLeft: 8 }}/>
      </OverlayTrigger>
    </div>
  ;

  const getApplyRanges = (item, editIndex) => {
    // 仅有效线索才包含转化价值
    // 基础上报为BASIC，价值分上报类型为VALUE_SCORE
    if (item?.actionType === ruleReportType
      && item?.reportContentType === VALUE_SCORE_REPORT
    ) {
      return item?.valueScoreApplyRanges || []
    }
    const newItem = _.isArray(item) && editIndex >= 0 ? item[editIndex] : item;
    return newItem?.applyRange || {}
  }

  // 渲染映射表详情 by fighting
  const renderApplyRangeDetail = (data, index, hasValueScore = false) => (<div>
    {hasValueScore && <div className="rule-item">
      <div className="rules-score">
        <span className="left"> 转化价值分 </span>
        <span className="right">{data?.score}</span>
      </div>
    </div>}
    {_.map(data?.applyRangeDetail, (item) => {
        const tags = hasValueScore ? tagNamesList[index] : tagNames[index];
        return !_.isEmpty(data.applyRangeDetail) ?
          <div className="rule-item">
            <span className="rule-key">
              {item.fieldScope === 'TAG' ? '线索标签'
                : (ruleItemNameMapping[item.fieldName]
                  || item.fieldName)}
            </span><span/>
            {item.fieldScope === 'TAG' && (
              <span className="rule-values">{tags ? tags.join(', ') : ''}</span>
            )}
            {item.fieldScope !== 'TAG' && (
              <span className="rule-values">{getLabelsFromIds(item).join(', ')}</span>
            )}
          </div> : null
      }
    )}
  </div>)

  // 有效综合线索 是否展示切换上报方式按钮  by fighting
  const [showCondition, setShowCondition] = useState(false);
  // 有效综合线索 -- 基础上报数据 add by fighting
  const [valueBasicData, setValueBasicApplyData] = useState({});
  const [reportCondition, setReportCondition] = useState(BASIC_REPORT);
  // 初始化上报条件
  const intReportConditions = (allRoles, actionType) => {
    const {
      applyRange = {},
      valueScoreApplyRanges = [],
      reportContentType = '',
    } = _.find(allRoles, ['actionType', actionType]) || {};
    return {
      applyRange,
      valueScoreApplyRanges,
      reportContentType: reportContentType || (_.isEmpty(valueScoreApplyRanges) ? BASIC_REPORT : VALUE_SCORE_REPORT)
    }
  }
  // 渲染整个ruleItem by fighting
  const renderApplyRange = (data, index, hasValueScore = false) => {
    const rules = data[index];
    const actionType = hasValueScore ? ruleReportType : rules?.actionType;
    const isHead = index === 0; // 是否是第一个元素
    const isTail = index === _.size(data) - 1; // 是否是最后一个元素
    const isMiddle = !isHead && !isTail; // 是否是中间的元素
    const showTitle = hasValueScore && isHead || !hasValueScore; // 是否展示标题
    return <li
      className={`item rule ${hasValueScore ? 'score' : ''}`}
      style={{
        borderTop: hasValueScore && (isTail || isMiddle) && 0,
        borderTopLeftRadius: hasValueScore && (isTail || isMiddle) && 0,
        borderTopRightRadius: hasValueScore && (isTail || isMiddle) && 0,
        borderBottom: hasValueScore && (isHead || isMiddle) && 0,
        borderBottomLeftRadius: hasValueScore && (isHead || isMiddle) && 0,
        borderBottomRightRadius: hasValueScore && (isHead || isMiddle) && 0
      }}
      key={index}>
      {/* 标题 */}
      {showTitle && <div className="item-left rule-name">
        <div className="rule-title">
          {renderHelpTips(`设置【${ruleTypeMapping[actionType]?.title}】规则`, ruleTypeMapping[actionType]?.iconDesc)}
        </div>
        <div className="action">
          <a
            aria-label="编辑"
            className="editable-icon"
            onClick={() => {
              const conditions = intReportConditions(allRoles, actionType);
              const {
                reportContentType = BASIC_REPORT,
                valueScoreApplyRanges = []
              } = conditions || {}
              setReportCondition(reportContentType)
              if (actionType === ruleReportType) {
                setShowCondition(true);
                setValueBasicApplyData(conditions);
                editRuleActionType(rules, hasValueScore? valueScoreApplyRanges: []);
              } else {
                setShowCondition(false);
                editRuleActionType(rules);
              }
            }}
          >
            <Icon name="pen-outlined" style={{ color: '#296BEF' }}/>
          </a>
        </div>
      </div>
      }
      {hasValueScore && (isTail || isMiddle) && _.size(data)>1 && <div className="split-line"/>}
      {/* 内容*/}
      <div className="item-right rule-list">
        <div className="content">
          {
            renderApplyRangeDetail(
              hasValueScore ? rules?.applyRange : getApplyRanges(rules),
              index,
              hasValueScore
            )
          }
        </div>
      </div>
    </li>
  }
  // 用来判断自定义状态是否为空
  const [customInputTemp, setCustomInputTemp] = useState('custom');
  // 编辑-渲染关系规则项 by fighting
  const renderEditApplyRangeDetail = (item, index, hasValueScore = false, editIndex) => {
    return <div className="form-in">
      <div className={!item.fieldName && !item.fieldScope ? 'has-error' : ''}>
        <Select
          className="filter-key"
          data={ruleLabelValueList[editIndex > 0 ? editIndex : 0]}
          value={item.fieldName || item.fieldScope}
          style={{ width: 300 }}
          onChange={(e, _value) => {
            changeRuleItemName(index, _value, editIndex);
          }}
        />
      </div>
      <div style={{
        width: 64,
        paddingLeft: 15,
        marginTop: 8
      }}>包括
      </div>
      {
        // 普通下拉框类型
        item.fieldScope !== 'TAG'
        && item.fieldName !== 'outerLeadsConvertType'
        && item.fieldName !== 'leadsStatus2' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
            className={(item.fieldValues.length === 0 || !_.isEmpty(item.fieldValuesDuplicate)) ? 'has-error' : ''}>
            <Select
              className="filter-values"
              multiple
              data={getDataFromItem(item)}
              value={getValuesFromIds(item)}
              style={{ width: 300 }}
              onChange={(e, _value) => {
                changeRuleItemValues(index, _value, editIndex);
              }}
            />
            {!_.isEmpty(item.fieldValuesDuplicate) && <span className="label-notice">当前有重复选项</span>}
          </div>
        )
      }
      {
        item.fieldName === 'leadsStatus2' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
            className={(item.fieldValues.length === 0  || !_.isEmpty(item.fieldValuesDuplicate))? 'has-error' : ''}>
            <Select
              className="filter-values"
              multiple
              data={industry.stateQueryOptions}
              value={getValuesFromIds(item).map((val) => parseInt(val, 10))}
              style={{ width: 300 }}
              SelectionDataComponent={StateSelectionComponent}
              onChange={(e, _value) => {
                changeRuleItemValues(index, _value, editIndex);
              }}
            />
            {!_.isEmpty(item.fieldValuesDuplicate) && <span className="label-notice">当前有重复选项</span>}
          </div>
        )
      }
      {
        // 自定义线索状态类型，input 类
        item.fieldName === 'outerLeadsConvertType' && (
          <div className={(_.isEmpty(customInputTemp)) ? 'has-error' : ''}>
            <Input
              placeholder="请输入自定义线索状态，以逗号分隔"
              className="input-values"
              value={item?.fieldValues.join(',')}
              style={{ width: 300 }}
              onChange={(e, value) => {
                setCustomInputTemp(value)
                changeInputValues(index, value, editIndex);
              }}
              status={item?.fieldValues.length === 0 ? 'has-error' : ''}
            />
          </div>
        )
      }
      {
        // 线索标签
        item.fieldScope === 'TAG' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
            className={(item.fieldValues.length === 0 || !_.isEmpty(item.fieldValuesDuplicate)) ? 'has-error' : ''}
          >
            <SelectTree
              className="filter-values"
              value={item.fieldValues}
              data={tagGroups}
              multiple={true}
              valueType="child"
              dropStyle={{ width: 600 }}
              style={{
                width: '300px',
              }}
              onChange={(e, value) => {
                changeRuleItemValues(index, value, editIndex);
              }}
            />
            {!_.isEmpty(item.fieldValuesDuplicate) && <span className="label-notice">当前有重复选项</span>}
          </div>
        )
      }
      <div className="close-wraper">
        <i
          className="icon icon-close2"
          onClick={(e) => {
            deleteRuleItem(index, editIndex);
          }}
        />
      </div>
    </div>
  }

  // 获取实际的editActionTypeItem by fighting
  const getEditActionTypeItem = item => item?.valueScoreApplyRanges || item;

  // 编辑-渲染关系规则列表 by fighting
  const renderEditRange = (data, hasValueScore = false, editIndex) => {
    return <div className={hasValueScore && 'dynamic-range'}>
      {
        _.map(data?.applyRangeDetail, (item, index) => (
          renderEditApplyRangeDetail(
            item, index, hasValueScore, editIndex
          )
        ))
      }
      <a
        className="edit"
        onClick={() => {
          addRuleItem(editIndex);
        }}
      >
        ＋添加条件
      </a>
    </div>
  }

  // add by fighting
  const ruleItemProps = {
    // 默认组件选中值
    defaultItemValue: {
      applyRange: {
        applyRangeType: 'CUSTOMIZE',
        logicRelation: 'OR',
        applyRangeDetail: [defaultApplyRangeDetailItem]
      },
    },
    inputComponent: (props) => {
      const { data = {}, idx = '', size } = props;
      setRuleSize(size);
      const hasValueScore = reportCondition === VALUE_SCORE_REPORT;
      const {
        score: scoreValue = '',
        scoreDuplicateMap = []
      } = getApplyRanges(getEditActionTypeItem(cloneEditActionTypeItem), idx) || {};
      // todo by fighting 判断转化价值分是否重复
      const scoreDuplicate = _.includes(scoreDuplicateMap, scoreValue);
      return <div key={idx} style={{ marginBottom: 20 }}>
        <div className="form-in">
        <span style={{
          display: 'flex',
          alignItems: 'center',
          paddingRight: 20,
          width: 100
        }}>转化价值分
      </span>
          <div
            className={(!ValueScorePattern.test(scoreValue) || scoreDuplicate) ? 'has-error' : ''}
          >
            <Input
              placeholder="请输入 1～10 的整数"
              className="input-values"
              value={scoreValue}
              style={{ width: 786 }}
              type='number'
              onChange={(e, value) => {
                changeRuleItemName('scoreInput', value, idx);
              }}
            />
            {!ValueScorePattern.test(scoreValue) && <span className="label-notice">输入格式必须为1～10 的整数</span>}
            {scoreDuplicate && <span className="label-notice">当前有重复选项</span>}
          </div>
        </div>
        <div style={{ marginLeft: 100 }}>
          {renderEditRange(data?.applyRange, hasValueScore, idx)}
        </div>
      </div>
    },
    inputComponentProps: {},
    addButtonPosition: 'bottom',
    addButtonText: '添加转化值分',
    addButtonTips: `（转化值分最少3个，最多10个，当前已添加${ruleSize}个）`,
    // 当删减至小于3个分段时就不再支持删减分值，增加至大于10个分段时就不再支持新增转化价值分
    hideDelBtn: ruleSize <= 3,
    hideAddBtn: ruleSize >= 10,
    // 组件传入的默认值
    value: getEditActionTypeItem(editActionTypeItem),
    onChange: (value) => {
      setRuleSize(_.size(value));
      setCloneEditActionTypeItem(value);
    }
  }
  return (
    <main className="main" id="leads-data">
      {uploadSteps()}
      <div className="card padding-normal">
        <div className="card-title">
          {renderHelpTips('设置上报规则', '多条上报件之间，为“或”关系')}
          <div className="card-tips">
            <span className="card-tips-content">【有效综合线索】新增支持使用转化价值分上报</span>
          </div>
        </div>
        <ul className="custom-infolist">
          {allRoles.map((rules, ruleIndex) => {
            const rangeData = getApplyRanges(rules);
            // 断是否是数组， 为数组则代表包含valueScoreApplyRanges by fighting
            const hasValueScore = _.isArray(rangeData);
            return !hasValueScore ? renderApplyRange(allRoles, ruleIndex) :
              _.map(rangeData, (scoreItem, scoreIndex) => {
                return renderApplyRange(rangeData, scoreIndex, hasValueScore);
              })
          })}
        </ul>
        <Dialog
          backdrop
          show={editDialogVisible}
          type="normal"
          title={ruleTypeMapping[showCondition? ruleReportType: editActionTypeItem.actionType]?.title}
          className="customrule-dialog data-upload-rule-dialog"
          style={{ width: '980px' }}
          contentStyle={{ background: '#F7F9FC' }}
          headerStyle={{ background: '#F7F9FC', borderRadius: 12 }}
          footerStyle={{ textAlign: 'right' }}
          submitLabel='保存修改'
          onClose={closeEditDialog}
          onCancel={closeEditDialog}
          onSubmit={submitEditDialog}
        >
          <div className="info-des-sec" style={{ paddingBottom: 23 }}>
            <div className="config-li">
              <div className="con-setting">
                <span className="tt">条件关系：或</span>
              </div>
              {showCondition && <div
                className="con-setting"
                style={{ marginBottom: 23 }}
              >
                {/* add by fighting  disabled={validFail()}*/}
                <RadioGroup
                  data={ruleReportOptions}
                  value={reportCondition}
                  onChange={(event, value) => {
                    setReportCondition(value);
                    resetRuleLabelList(true, value);
                    // 这里要重新设置下editActionTypeItem
                    setCloneEditActionTypeItem(getEditActionTypeItem(editActionTypeItem))
                  }}
                />
              </div>}
              {reportCondition === VALUE_SCORE_REPORT ? <DynamicInputGroup
                {...ruleItemProps}
              /> : <div style={{ width: 1000 }}>
                {renderEditRange(getApplyRanges(showCondition? valueBasicData: editActionTypeItem))}
              </div>
              }
            </div>
          </div>
        </Dialog>
      </div>
    </main>
  );
};
